import React, { useState } from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";

/** Remove caracteres invisíveis que mantêm `message.text` truthy sem conteúdo visível. */
const stripForTranscription = (value) =>
  value == null ? "" : String(value).replace(/[\u200B-\u200D\uFEFF]/g, "").trim();

const TRANSCRIPTION_PLACEHOLDERS = new Set(
  ["[mensagem]", "[mensagem gupshup]", "[áudio]", "[audio]"].map((s) => s.toLowerCase())
);

/** Texto de transcrição exibível: não vazio, não placeholder, não só a URL do áudio. */
function getTranscriptionText(message, audioUrl) {
  if (!message) return "";
  if (message.transcription != null) {
    const t = stripForTranscription(message.transcription);
    if (t) return t;
  }
  const fromText = stripForTranscription(message.text);
  if (!fromText) return "";
  if (TRANSCRIPTION_PLACEHOLDERS.has(fromText.toLowerCase())) return "";
  if (audioUrl && fromText === stripForTranscription(String(audioUrl))) return "";
  return fromText;
}

const AudioMessage = ({ message }) => {
  const [showTranscription, setShowTranscription] = useState(false);
  const theme = useTheme(); // Obtém o tema atual
  const audioUrl = message?.audio || message?.url;
  if (!audioUrl || !String(audioUrl).trim()) return null;

  const transcriptionText = getTranscriptionText(message, audioUrl);

  const toggleTranscription = () => {
    setShowTranscription((prev) => !prev);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        maxWidth: "100%",
        width: "100%",
        boxSizing: "border-box",
        // Deixa o fundo e o raio de borda por conta do balão principal (MessageItem),
        // evitando um "box dentro do box" que aperta o conteúdo.
      }}
    >
      <audio
        controls
        style={{
          width: "100%",
          maxWidth: "100%",
          display: "block",
        }}
      >
        <source src={audioUrl} type="audio/mpeg" />
        Seu navegador não suporta áudio.
      </audio>
      {transcriptionText && (
        <Box>
          <Button
            size="small"
            variant="text"
            onClick={toggleTranscription}
            sx={{
              textTransform: "none",
              padding: 0,
              fontSize: "0.9rem",
              color: theme.palette.text.primary, // Ajustado para o texto primário
              "&:hover": {
                textDecoration: "underline",
                color: theme.palette.secondary.main, // Destacado no hover
              },
              "&:focus": {
                outline: "1px solid",
                outlineColor: theme.palette.primary.main, // Destaque ao focar
              },
            }}
          >
            {showTranscription ? "Ocultar transcrição" : "Ver transcrição"}
          </Button>
          {showTranscription && (
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.text.secondary,
                fontStyle: "italic",
                marginTop: 1,
                wordWrap: "break-word",
              }}
            >
              {transcriptionText}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default AudioMessage;
